import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/support.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";
import Pagination from "@mui/material/Pagination";

function Support() {
    const [usersData, setUsersData] = useState(null);
    const [ticketCategories, setTicketCategories] = useState([]);
    const [ticketLists, setTicketLists] = useState([]);
    const config = configModule.config();
    const [formData, setFormData] = useState({
        category_id: "",
        subject: "",
        message: ""
    });
    const [page, setPage] = useState(1);
    const rowsPerPage = 10;

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const getMessageData = async () => {

        try {
            const response = await axios.get(
                `${config.apiBaseUrl}/get-ticketcategories/${usersData?.id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const categoryList = response.data?.cat;
            const dataList = response.data?.data;
            setTicketCategories(categoryList);
            setTicketLists(dataList);

        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Something went wrong";

            toast.error(message);
        }
    };

    useEffect(() => {
        if (usersData?.id) {
            getMessageData();
        }
    }, [usersData]);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            const decoded = jwtDecode(token);
            setUsersData(decoded);
        }
    }, []);

    const handleSubmitTicket = async () => {
        try {
            if (!formData.category_id) {
                toast.error("Please select a category");
                return;
            }

            if (!formData.subject.trim()) {
                toast.error("Please enter a subject");
                return;
            }

            if (!formData.message.trim()) {
                toast.error("Please enter your message");
                return;
            }

            const payload = {
                investor_id: usersData?.id,
                category_id: formData.category_id,
                subject: formData.subject,
                message: formData.message
            };

            const response = await axios.post(
                `${config.apiBaseUrl}/raise-ticket`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data?.success) {
                toast.success(
                    response.data?.message || "Ticket raised successfully"
                );

                setFormData({
                    category_id: "",
                    subject: "",
                    message: ""
                });
                getMessageData();
            } else {
                toast.error(
                    response.data?.message || "Unable to raise ticket"
                );
            }

        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Something went wrong";

            toast.error(message);
        }
    };

    const totalPages = Math.ceil((ticketLists?.length || 0) / rowsPerPage);

    const paginatedTicketData = ticketLists?.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    ) || [];

    const formatPaymentDate = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const day = String(d.getUTCDate()).padStart(2, "0");
        const month = String(d.getUTCMonth() + 1).padStart(2, "0");
        const year = d.getUTCFullYear();

        let hours = d.getUTCHours();
        const minutes = String(d.getUTCMinutes()).padStart(2, "0");

        const ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12;
        hours = hours || 12;

        hours = String(hours).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    };

    return (
        <div className='dashboardmain-st'>
            <Header pageName="Support" />
            <div className="body-dashboard">
                <div className="page-header">
                    <div className="page-eyebrow">Help</div>
                    <div className="page-title">Support</div>
                </div>

                <div className="lxp-support-grid">
                    <div className="lxp-card">
                        <div className="lxp-card-header">
                            <div className="lxp-card-title">Raise a Ticket</div>
                        </div>
                        <div style={{ padding: "16px" }}>
                            <div className="lxp-form-field">
                                <div className="lxp-form-label">Category</div>
                                <select
                                    className="lxp-form-select"
                                    name="category_id"
                                    value={formData.category_id}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Category</option>

                                    {ticketCategories?.length > 0 &&
                                        ticketCategories.map((item, index) => (
                                            <option key={index} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="lxp-form-field">
                                <div className="lxp-form-label">Subject</div>
                                <input
                                    className="lxp-form-input"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    placeholder="Brief subject line"
                                />
                            </div>
                            <div className="lxp-form-field">
                                <div className="lxp-form-label">Message</div>
                                <textarea
                                    className="lxp-form-textarea"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Describe your query…"
                                />
                            </div>
                            <button
                                className="lxp-btn lxp-btn-gold"
                                style={{ width: "100%", justifyContent: "center" }}
                                onClick={handleSubmitTicket}
                            >
                                Submit Ticket
                            </button>
                        </div>
                    </div>
                    <div>
                        <div className="lxp-card" style={{ marginBottom: "16px" }}>
                            <div className="lxp-card-header">
                                <div className="lxp-card-title">Contact Us</div>
                            </div>
                            <div className="lxp-support-channels">
                                <a className="lxp-support-channel lxp-phone" href="tel:+917592961313">
                                    <div className="lxp-channel-icon">
                                        <svg viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round"
                                            fill="none" stroke="currentColor">
                                            <path d="M22 16.9A5 5 0 0 1 17 22C9.27 22 3 15.73 3 8a5 5 0 0 1 5.1-5l1.27 5.35-2.1 2.1a14.9 14.9 0 0 0 6.28 6.28l2.1-2.1L20.65 15.9z" />
                                        </svg>
                                    </div>

                                    <div>
                                        <div className="lxp-channel-title">Call us</div>
                                        <div className="lxp-channel-sub">
                                            +91 7592961313 · Mon–Sat, 09:30am–6:30pm
                                        </div>
                                    </div>
                                </a>

                                <a
                                    className="lxp-support-channel lxp-whatsapp"
                                    href="https://wa.me/917592961313?text=Hi%2C%20can%20you%20help%20me%20with%20a%20query"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="lxp-channel-icon">
                                        <svg viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round"
                                            fill="none" stroke="currentColor">
                                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                        </svg>
                                    </div>

                                    <div>
                                        <div className="lxp-channel-title">WhatsApp</div>
                                        <div className="lxp-channel-sub">Chat with us instantly</div>
                                    </div>
                                </a>

                                <a
                                    className="lxp-support-channel lxp-email"
                                    href="https://mail.google.com/mail/?view=cm&fs=1&to=info@lexoraholdings.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="lxp-channel-icon">
                                        <svg viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round"
                                            fill="none" stroke="currentColor">
                                            <rect x="2" y="4" width="20" height="16" rx="2" />
                                            <path d="M22 7l-10 6L2 7" />
                                        </svg>
                                    </div>

                                    <div>
                                        <div className="lxp-channel-title">Email</div>
                                        <div className="lxp-channel-sub">
                                            info@lexoraholdings.com
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* <div className="lxp-card">
                            <div className="lxp-card-header">
                                <div className="lxp-card-title">FAQs</div>
                            </div>
                            <div className="lxp-faq-item">
                                <div className="lxp-faq-q" onClick={(e) => e.currentTarget.parentElement.classList.toggle("open")}>When
                                    are monthly returns credited?<svg viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth="1">
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                </div>
                                <div className="lxp-faq-a">Returns are processed between the 1st and 5th of every month
                                    for the previous month's earnings.</div>
                            </div>
                            <div className="lxp-faq-item" >
                                <div className="lxp-faq-q" onClick={(e) => e.currentTarget.parentElement.classList.toggle("open")}>Can I
                                    withdraw before the lock-in period ends?<svg viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth="1">
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg></div>
                                <div className="lxp-faq-a">Early exits are evaluated case by case. Reach out to your
                                    relationship manager to discuss options.</div>
                            </div>
                            <div className="lxp-faq-item" >
                                <div className="lxp-faq-q" onClick={(e) => e.currentTarget.parentElement.classList.toggle("open")}>How is
                                    current portfolio value calculated?<svg viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth="1">
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg></div>
                                <div className="lxp-faq-a">We apply a fixed annual appreciation rate to your invested
                                    amount, compounding once per completed year since your investment date.</div>
                            </div>
                            <div className="lxp-faq-item" >
                                <div className="lxp-faq-q" onClick={(e) => e.currentTarget.parentElement.classList.toggle("open")} >How do
                                    I update my contact details?<svg viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth="1">
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg></div>
                                <div className="lxp-faq-a">Contact the Lexora team via support ticket or WhatsApp — our
                                    team will update your details within 24 hours.</div>
                            </div>
                        </div> */}
                    </div>
                </div>

                <div style={{ background: "#fff", overflow: "auto" }}>
                    <div className="card-header-st" style={{ minWidth: "752px" }}>
                        <div>
                            <div className="card-title-st">Ticket history</div>
                        </div>
                    </div>

                    <div style={{ minWidth: "752px" }}>
                        <div className="d-flex w-100">
                            <div className="w-15 d-center comcolldbtab-st hdcoldbtab-st">Category</div>
                            <div className="w-15 d-center comcolldbtab-st hdcoldbtab-st">Subject</div>
                            <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Message</div>
                            <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Reply</div>
                            <div className="w-15 d-center comcolldbtab-st hdcoldbtab-st">Replied At</div>
                            <div className="w-15 d-center comcolldbtab-st hdcoldbtab-st">Status</div>
                        </div>
                        <div className='main-bodytab-st'>
                            {paginatedTicketData?.map((item, index) => (
                                <div className="d-flex w-100" key={index}>
                                    <div className="w-15 d-center comcolldbtab-st bdycoldbtab-st">{item.name}</div>
                                    <div className="w-15 d-center comcolldbtab-st bdycoldbtab-st">{item.subject}</div>
                                    <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">{item.message}</div>
                                    <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">{item.reply}</div>
                                    <div className="w-15 d-center comcolldbtab-st bdycoldbtab-st">{item?.reply_date ? formatPaymentDate(item?.reply_date) : ""}</div>
                                    <div className="w-15 d-center comcolldbtab-st bdycoldbtab-st">
                                        <span
                                            className={
                                                item.status === "Resolved"
                                                    ? "pill pill-active"
                                                    : item.status === "In Progress" || item.status === "Open"
                                                        ? "pill pill-pending"
                                                        : "pill pill-delayed"
                                            }
                                        >
                                            {item.status}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-between align-items-center totalinfooter-st " style={{ minWidth: "752px" }}
                    >
                        <p
                            className="mb-0 hdcoldbtab-st ps-2 p-0"
                            style={{
                                background: "transparent",
                                border: "none",
                            }}
                        >
                            Showing{" "}
                            {ticketLists?.length === 0
                                ? 0
                                : (page - 1) * rowsPerPage + 1}
                            {" - "}
                            {Math.min(
                                page * rowsPerPage,
                                ticketLists?.length || 0
                            )}
                            {" of "}
                            {ticketLists?.length || 0} records
                        </p>

                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={(event, value) => setPage(value)}
                            color="primary"
                            shape="rounded"
                            showFirstButton
                            showLastButton
                            sx={{
                                "& .MuiPaginationItem-root": {
                                    color: "#1e386e",
                                    borderColor: "#1e386e",
                                },

                                "& .MuiPaginationItem-root:hover": {
                                    backgroundColor: "#1e386e20",
                                },

                                "& .Mui-selected": {
                                    backgroundColor: "#1e386e !important",
                                    color: "#fff",
                                    borderColor: "#1e386e",
                                },

                                "& .MuiPaginationItem-icon": {
                                    color: "#1e386e",
                                },
                            }}
                        />
                    </div>
                </div>
            </div>

            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: "#0a1628",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "14px 18px",
                    },
                    success: {
                        iconTheme: {
                            primary: "#22c55e",
                            secondary: "#fff",
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: "#ef4444",
                            secondary: "#fff",
                        },
                    },
                }}
            />
        </div>
    )
}

export default Support;
